module.exports = __webpack_public_path__ + "static/img/assistant.c86896f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/assistant.jpg
// module id = rRgt
// module chunks = 0